<script setup lang="ts">
import { computed, ref, watch } from 'vue'

import { resolveProfilePictureUrl, useAccount } from '@/features/account'
import { Icon } from '@/shared/ui'

const { account, accountDetail } = useAccount()
const failed = ref(false)
const picture = computed(() =>
  resolveProfilePictureUrl(
    accountDetail.value?.profile_picture_path ?? account.value?.profile_picture_path,
  ),
)
watch(picture, () => {
  failed.value = false
})
</script>

<template>
  <span
    class="message-bubble__user-avatar grid size-10 shrink-0 place-items-center overflow-hidden rounded-full bg-surface text-primary"
    aria-hidden="true"
  >
    <img
      v-if="picture && !failed"
      :src="picture"
      alt=""
      class="size-full object-contain"
      @error="failed = true"
    />
    <Icon v-else name="user" :size="20" weight="light" />
  </span>
</template>
